import { msg } from "@lingui/core/macro";

export const maxTotalPermitsInPeriodRuleMessages = {
	name: msg({
		comment: "Name of a permit type rule, shown in the dashboard rules list. Noun phrase, not an instruction",
		message: "Maximum Permit Limit",
	}),
	description: msg({
		comment:
			"One-line description of the Maximum Permit Limit rule in the dashboard rules list. The rule caps how many permits may be taken out within a repeating period, across every tenant",
		message: "Limits the total number of permits that can be created within a day, week, or month.",
	}),
	errors: {
		limitReachedDay: msg({
			comment:
				"Shown to a parker when their permit cannot be created because the day's permit cap is full. {amount} is the configured maximum number of permits allowed per day",
			message: "The limit of {amount} permit(s) within 1 day has been reached.",
		}),
		limitReachedDays: msg({
			comment:
				"Shown to a parker when their permit cannot be created because the cap for a rolling multi-day window is full. {amount} is the maximum permits allowed, {days} is the length of that window in days",
			message: "The limit of {amount} permit(s) within {days} days has been reached.",
		}),
		limitReachedWeek: msg({
			comment:
				"Shown to a parker when their permit cannot be created because the week's permit cap is full. {amount} is the configured maximum number of permits allowed per week",
			message: "The limit of {amount} permit(s) this week has been reached.",
		}),
		limitReachedMonth: msg({
			comment:
				"Shown to a parker when their permit cannot be created because the month's permit cap is full. {amount} is the configured maximum number of permits allowed per calendar month",
			message: "The limit of {amount} permit(s) this month has been reached.",
		}),
		limitReachedNever: msg({
			comment:
				"Shown to a parker when their permit cannot be created because a lifetime cap that never resets is full. {amount} is the total number of permits ever allowed",
			message: "The limit of {amount} permit(s) has been reached.",
		}),
	},
} as const;
